import React, { Component } from 'react';
import { Image, Col, Row, Container } from 'react-bootstrap';
import Arrow from '../../../img/Arrow.svg'
import Documents from '../../../img/NewPNG/Pasos_Fondo1.png'
import Reloj from '../../../img/NewPNG/Pasos_Fondo2.png'
import Sobre from '../../../img/NewPNG/Pasos_Fondo3.png'
import Translate from '../../../../../translate'
import './index.css'

class Unete extends Component {
  constructor(props){
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <div className='frecuentes-background section-container' id='registrate'>
        <div className='frecuentes-outter'>
          <Container className='responsive-container'>
            <Row>
              <Col md={12}>
                <p className='title-section'>{Translate[this.props.lan].landing3.seccion6.titulo}</p>
              </Col>
              <Col md={12} className={'sectionColumnsTitles'}>
                <div className={'sectionDivTitles'}>
                  <p className='subtitle-section'>{Translate[this.props.lan].landing3.seccion6.subtitulo}</p>
                </div>
              </Col>
              <Col xs={12}>
                <p
                  className='faq-link'
                  style={{textAlign:'center'}}
                  onClick={()=>window.open(window.location.origin + '/faq','_blank')}
                >
                  {Translate[this.props.lan].landing3.hipervinculo2} <Image src={Arrow} style={{marginLeft: '5px'}} width={25}/>
                </p>
              </Col>
              <Col>
                <div className='frecuentes-container'>
                  <Row style={{alignItems: 'center'}}>
                    <Col sm={12} md={4}>
                      <div className='image-container'>
                        <Image src={Documents}/>
                      </div>
                      <div style={{height:20}}/>
                      <p className='center frecuentes-title'>{Translate[this.props.lan].landing3.seccion6.ingresa}</p>
                      <p className='center frecuentes-text'>{Translate[this.props.lan].landing3.seccion6.ingresaDesc}</p>
                    </Col>
                    <Col className='align-line-mobile'>
                      <div className='divisor-line-mobile'/>
                    </Col>
                    <Col sm={12} md={4} className="frecuentesDivLineasCol" >
                      <div className='image-container'>
                        <Image src={Reloj}/>
                      </div>
                      <div style={{height:20}}/>
                      <div className='frecuentesDivLineas'>
                        <p className='center frecuentes-title'>{Translate[this.props.lan].landing3.seccion6.respuesta}</p>
                        <p style={{marginBottom: '0px'}} className='center frecuentes-text'>{Translate[this.props.lan].landing3.seccion6.respuestaDesc}</p>
                      </div>
                    </Col>
                    <Col className='align-line-mobile'>
                      <div className='divisor-line-mobile'/>
                    </Col>
                    <Col sm={12} md={4}>
                      <div className='image-container'>
                        <Image src={Sobre}/>
                      </div>
                      <div style={{height:20}}/>
                      <p className='center frecuentes-title'>{Translate[this.props.lan].landing3.seccion6.bienvenido}</p>
                      <p className='center frecuentes-text'>{Translate[this.props.lan].landing3.seccion6.bienvenidoDesc}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export default Unete
